import React, { PureComponent } from "react";
import { convertToReadableTime } from "../utils/ConvertTime";
import styled from "styled-components";

export interface Props {
  title: string;
  duration: number;
  playlistItemIndex: number;
  currentEpisode: string;
  select: (...args: any[]) => void;
  key: number;
  customColors?: any;
}

/**
 * PlaylistItem label - Renders audio label when a program's episode has a brand property with value true (boolean).
 * If there is no sponsor and thus no brand property it falls back to the program its programType.
 */
export default class PlaylistItem extends PureComponent<any, any> {
  private playlistItemElement: HTMLDivElement;

  constructor(props: any) {
    super(props);

    this.state = {
      playlistItemDuration: convertToReadableTime(props.duration, "u:mm:ss"),
      windowWidth: null,
      isCurrent: false,
      hascolors: this.props.customColors.length > 0 ? true : false
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillMount() {
    window.removeEventListener("resize", this.handleResize);
  }

  getPlayListItem() {
    return this.playlistItemElement;
  }

  /**
   * Handles the resizing of the playlistitems with a delay.
   * We size them using javascript to overcome the differences in scrollbar
   * widths in various browsers.
   */
  handleResize = e => {
    let resizeWindow;
    clearTimeout(resizeWindow);

    if (!resizeWindow) {
      resizeWindow = setTimeout(() => {
        resizeWindow = null;
        this.setState({
          windowWidth: window.innerWidth - 5
        });
      }, 500);
    }
  };

  select = () => {
    this.props.select(this.props.playlistItemIndex);
  };

  render() {
    return (
      <PlayListItem
        ref={ref => {
          this.playlistItemElement = ref!;
        }}
        onClick={this.select}
        style={{
          width: `${this.state.windowWidth || window.innerWidth - 5}px`
        }}
        className={`playlist-item ${
          this.props.playlistItemIndex === this.props.currentEpisode
            ? "isCurrent"
            : ""
        }`}
        customColors={this.state.hascolors ? this.props.customColors : []}
      >
        <PlayListItemIcon className={"playlist-item-icon"}>
          {this.props.playlistItemIndex + 1}
        </PlayListItemIcon>
        <PlayListItemTitle className={"playlist-item-title"}>
          {this.props.title}
        </PlayListItemTitle>
        <PlayListItemDuration className={"playlist-item-duration"}>
          {this.state.playlistItemDuration}
        </PlayListItemDuration>
      </PlayListItem>
    );
  }
}

const PlayListItem: any = styled.div`
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 1.6;
  min-height: 25px;
  font-size: 14px;
  color: ${(props: any) =>
    props.customColors.length > 0 ? props.customColors[1] : "#fff"};
  transition: color 0.2s ease-in-out;
  > span {
  }
  &:hover {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }
  &.isCurrent {
    color: ${(props: any) =>
      props.customColors.length > 0 ? props.customColors[0] : "#ffcb2e"};
    transition: color 0.2s ease-in-out;
  }
`;

const PlayListItemIcon: any = styled.span`
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  flex: 0.4;
  opacity: 0.8;
  font-size: 12px;
  align-items: center;
  justify-content: flex-start;
  margin: 0 5px;
  max-width: 20px;
  min-width: 15px;
`;

const PlayListItemTitle: any = styled.span`
  flex: 8.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin-right: 10px;
`;

const PlayListItemDuration: any = styled.span`
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  flex: 1;
  text-align: right;
  opacity: 0.8;
  font-size: 12px;
  align-items: center;
  justify-content: flex-end;
  padding-right: 4px;
`;
